(function () {
  displayFeaturedAPIs();

  const globalFilter = document.body.getAttribute("globalFilter");
  if (globalFilter) {
    const globalFilterItems = document.querySelectorAll("#global-filter .select-value");
    for (let selectList = 0; selectList < globalFilterItems.length; selectList++) {
      globalFilterItems[selectList].addEventListener("click", () => {
        const cardElements = document.querySelector(".featured-apis .api-cards");
        cardElements.innerHTML = "";
        displayFeaturedAPIs();
      });
    }
  }

  /**
   * Functionality of selecting featured APIs, B version.
   */
  function displayFeaturedAPIs() {
    fetch("./assets/javascripts/featured-api.generated.json")
      .then((response) => response.json())
      .then((data) => {
        filteredData = data;

        // Use the current date as seed, as we want to keep the random values consistent between devices.
        const date = new Date();
        const seed = date.getUTCFullYear() * 365 + date.getUTCMonth() * 30 + date.getUTCDate();

        const pickedProductLines = new Set();
        const productInfo = [];
        let attempts = 0;
        const currentGlobalFilter = document.body.getAttribute("globalFilter");
        if (currentGlobalFilter && currentGlobalFilter !== "global") {
          const productsOfLine = filteredData.filter((p) => p.productline === "Foundational Services");
          const productCount = productsOfLine.length;

          productInfo.push({
            productLine: "Foundational Services",
            productCount: productCount,
          });
        } else {
          while (pickedProductLines.size < 4 && attempts < filteredData.length) {
            // Ensure the sine function produces a value between 0 and 1.
            const randomValue = (Math.sin(seed + attempts) + 1) / 2;

            // Multiply the value by data.length to get a random index between 0 and data.length-1.
            const randomIndex = Math.floor(randomValue * filteredData.length);
            const productLine = filteredData[randomIndex].productline;

            // Pick different product lines.
            if (!pickedProductLines.has(productLine)) {
              pickedProductLines.add(productLine);

              const productsOfLine = filteredData.filter((p) => p.productline === productLine);
              const productCount = productsOfLine.length;

              productInfo.push({
                productLine: productLine,
                productCount: productCount,
              });
            }

            attempts++;
          }
        }

        const tileContainer = document.querySelector(".featured-apis .api-cards");
        while (tileContainer.firstChild) {
          tileContainer.removeChild(tileContainer.firstChild);
        }

        productInfo.forEach((product) => {
          const tile = document.createElement("a");
          tile.classList.add("card");
          tile.href = "apis.html?productLine=" + encodeURIComponent(product.productLine);
          const tileContent = document.createElement("div");
          tileContent.classList.add("card-content");
          const title = document.createElement("h3");
          title.textContent = product.productLine;

          const body = document.createElement("div");
          body.classList.add("card-body");

          const apiCount = document.createElement("p");
          apiCount.classList.add("api-count");
          if (product.productCount === 1) {
            apiCount.textContent = `1 API`;
          } else {
            apiCount.textContent = `${product.productCount} APIs`;
          }

          const productLinkText = document.createElement("p");
          productLinkText.textContent = `Browse ${product.productLine} API catalogue.`;

          body.appendChild(apiCount);
          body.appendChild(productLinkText);
          tileContent.appendChild(title);
          tileContent.appendChild(body);
          tile.appendChild(tileContent);
          tileContainer.appendChild(tile);
        });

        resizeButtonWrapper();
      })
      .catch((err) => {
        console.error("Error fetching the JSON file:", err);
      });
  }

  /**
   * Hack to adjust the width of the `.button-wrapper` element to match the
   * furthest right pixel of its previous sibling's children.
   */
  function resizeButtonWrapper() {
    const buttonWrapper = document.querySelector(".featured-apis .button-wrapper");
    const previousSibling = buttonWrapper.previousElementSibling;

    if (buttonWrapper && previousSibling) {
      // Compute rightmost edge of all children inside previousSibling.
      let rightmostEdge = 0;
      for (const child of previousSibling.children) {
        const rect = child.getBoundingClientRect();
        const childRightEdge = rect.left + rect.width;
        if (childRightEdge > rightmostEdge) {
          rightmostEdge = childRightEdge;
        }
      }

      const wrapperLeft = buttonWrapper.getBoundingClientRect().left;
      const desiredWidth = rightmostEdge - wrapperLeft;
      buttonWrapper.style.width = `${desiredWidth}px`;
    }
  }

  window.addEventListener("resize", resizeButtonWrapper);
})();
